import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect, useDispatch } from 'react-redux';
import Icon from 'components/util-components/Icon';
import history from '../../history'

import {
  EditOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { signOut } from 'redux/actions/Auth';
const menuItem = [
  {
    title: "Profile",
    icon: EditOutlined,
    path: "/app/dashboards/profile"
  }
]

export const NavProfile = () => {
  const dispatch = useDispatch();

  const signOutFn = async () => {
    localStorage.clear();
    await dispatch(signOut())
  }

  const onProfilePage = () => {

  }
  const profileImg = "/img/avatars/thumb-1.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <div className="pl-3">
            <h4 className="mb-0">{localStorage.getItem('firstName')} {localStorage.getItem('lastName')}</h4>
            <span className="text-muted">{localStorage.getItem('UserID')}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={e => signOutFn()}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={profileImg} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null)(NavProfile)
